import * as React from "react";

import { cn } from "@/lib/utils";

type TagProps = React.ComponentProps<"span"> & {
  /** Geist Mono for file and receipt numbers. */
  mono?: boolean;
};

/**
 * A neutral label for visa types, knowledge tags and file numbers: `fill-2`,
 * `rounded-xs`, 12px. Never colored; status belongs to `StatusBadge`.
 */
function Tag({ mono = false, className, ...props }: TagProps) {
  return (
    <span
      data-slot="tag"
      className={cn(
        "inline-flex h-5 w-fit max-w-full shrink-0 items-center gap-1 truncate rounded-xs bg-fill-2 px-1.5 text-sm whitespace-nowrap text-fg-2 [&_svg]:size-3 [&_svg]:shrink-0",
        mono && "font-mono",
        className
      )}
      {...props}
    />
  );
}

export { Tag };
export type { TagProps };
